export function params() {
    let paramString = window.location.search.substring(1),
    paramSplit = paramString.split("&"),
    result: any = {};

    paramSplit.forEach(x => {
        if(x) {
            let split = x.split("=");
            result[split[0]] = decodeURIComponent(split[1]);
        }
    });

    return result;
}

export function deleteParam(p: string) : void{
    let parameters = params();
    delete parameters[p];
    var path = window.location.pathname + '?' + serialize(parameters);
    if(path.endsWith("?")){
        path = path.substring(0, path.length - 1);
    } 
    history.pushState({}, document.title, path);
}

export function serialize(obj: any, uppercase: boolean = false) {
    var str = [];
    for(var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push((uppercase ? encodeURIComponent(p).toUpperCase() : encodeURIComponent(p)) + "=" + encodeURIComponent(obj[p] || ""));
        }
    return str.join("&");
}